export enum ServiceLevel {
    LOW,
    HIGH,
}

export function getServiceLevel(): ServiceLevel {
    if (!window.SERVER) {
        return ServiceLevel.LOW;
    }
    if (!window.SERVER.USER) {
        return ServiceLevel.LOW;
    }
    if (window.SERVER.USER.service_flags === null) {
        return ServiceLevel.LOW;
    }
    if (window.SERVER.USER.service_flags > 0) {
        return ServiceLevel.HIGH;
    }
    if (window.SERVER.USER.plan_price > 0) {
        return ServiceLevel.HIGH;
    }
    return ServiceLevel.LOW;
}

export function hasFeatureEnabled(featureFlagName: string): boolean {
    if (!window.SERVER) {
        return false;
    }
    if (!window.SERVER.USER) {
        return false;
    }
    if (!window.SERVER.USER.feature_flags) {
        return false;
    }
    return window.SERVER.USER.feature_flags.includes(featureFlagName);
}

export function hasTransmogFeatureEnabled(): boolean {
    if (hasFeatureEnabled('transmog_dashboard')) {
        return true;
    }
    // Allow staff to test while impersonating via URL param
    if (window.SERVER?.IMPERSONATING) {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get('enable_transmog') === '1';
    }
    return false;
}

export function getPlanDisplayName(): string | undefined {
    return SERVER?.USER?.plan_display_name;
}
